import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing, hex2rgba} from '../theme/theme'

export const inputClasses = {
  textField: css`
    ${cssTheme.components.textFields.outline.bgColorError.token}: ${hex2rgba(cssTheme.colors.cinnabar.toxic.hex, 0.1)};

    & input::placeholder {
      color: ${cssTheme.default.day.textMinor};
      opacity: 1;
    }

    & input[type='number'] {
      -moz-appearance: textfield;
    }

    & input[type='tel'] {
      font-size: 16px;

      [dir='rtl'] & {
        direction: ltr;
        text-align: right;
      }
    }

    & input::-webkit-outer-spin-button,
    & input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  `,
  clearIcon: css`
    cursor: pointer;
  `,
  pending: css`
    opacity: 1;

    & input::placeholder {
      color: white;
      opacity: 1;
    }
  `,
}

export const spinner = css`
  @keyframes rotating {
    to {
      transform: rotate(360deg);
    }
  }
  opacity: 1;
  color: white;
  inline-size: ${spacing(7)};
  animation: rotating 1s linear infinite;
`

